/* eslint-disable global-require */
/* eslint-disable import/no-named-as-default */
import './nav-drawer.styles.scss';

import angular from 'angular';
import NavService from './nav-drawer.service';

export default angular.module('directives.abNavDrawer', [NavService])
  .directive('abNavDrawer', () => {
    'ngInject';

    return {
      restrict: 'E',
      templateUrl: require('./nav-drawer.template.html'),
    };
  })
  .name;
